module.exports = __webpack_public_path__ + "img/fjern.58620b7e.svg";